<template>
	<Row class="bg-white">
		<Container>
			<article
				v-if="post"
				class="post-178 page type-page status-publish entry"
			>
				<header class="legal-disclosure">
					<h1
						v-if="post.title"
						v-html="post && post.title"
						class="entry-title"
					></h1>
				</header>

				<div
					class="entry-content legal-disclosure"
					v-html="contentFormatter(post.content)"
				></div>
			</article>
		</Container>
	</Row>

	<Head>
		<Title>Artificial Intelligence Disclosure - StocksToTrade</Title>
		<Meta
			name="description"
			content="Last Revised: December 27, 2019 Nothing in this Privacy Statement may be construed to create any obligation for the Company beyond what is required by applicable law. California residents click here to access our California Consumer Protection Act (CCPA) Notice. This Privacy Statement (“Privacy Statement” or “Statement”) describes the practices of StocksToTrade.Com Inc. (“StocksToTrade,” “STT,”…"
		/>

		<Link
			:href="config.current_hostname.slice(0, -1) + '/ai-disclosure/'"
			rel="canonical"
		/>
		<Meta
			:content="config.current_hostname.slice(0, -1) + '/ai-disclosure/'"
			property="og:url"
		/>
	</Head>
</template>

<script setup>
import { load } from "cheerio";

const config = useRuntimeConfig().public;
const router = useRoute();

const aiDisclosureDataKey = "ai-disclosure-page-data";

const { data } = await useAsyncData(aiDisclosureDataKey, async () => {
	const results = await $fetch(
		`${config.hostname}wp-json/wp/v2/pages?slug=ai-disclosure&_embed`
	);
	const page = results?.[0];
	if (page) {
		return {
			post: {
				title: page.title.rendered,
				content: page.content.rendered
			},
			metadata: page.yoast_head_json,
			yoast: page.yoast_head
		};
	}
});

const { post, metadata, yoast } = data.value;

const contentFormatter = (content) => {
	const $ = load(content, {
		decodeEntities: false, // Prevent HTML entity decoding
		xmlMode: false // Do not treat input as XML
	});

	$("h1").each(function () {
		$(this).replaceWith(
			$("<h2>")
				.html($(this).html())
				.attr("class", $(this).attr("class"))
				.addClass("converted-from-h1") // Add a class to mark that these were originally h1
		);
	});

	// Then convert original h2 to h3, excluding those just converted from h1
	$("h2")
		.not(".converted-from-h1")
		.each(function () {
			$(this).replaceWith(
				$("<h3>").html($(this).html()).attr("class", $(this).attr("class"))
			);
		});

	return $.html();
};

const head_schema_seo = computed(() => {
	const experiment = Object.entries(this.metadata);
	const filtered = experiment.filter((item) =>
		["canonical", "schema_json"].includes(item[0])
	);
	return filtered;
});
const head_seo = computed(() => {
	const experiment = Object.entries(this.metadata);
	const filtered = experiment.filter(
		(item) =>
			![
				"title",
				"robots",
				"canonical",
				"schema_json",
				"WordPressAuthor_YoastHeadJson_Schema_"
			].includes(item[0])
	);
	return filtered;
});
</script>

<style lang="scss">
@use "../assets/legal-pages" as *;

.legal-disclosure {
	ul {
		list-style: disc;
		margin-left: 20px;
	}

	h1 {
		font-size: 3.6rem;
	}

	h2 {
		font-size: 2.4rem;
	}

	p {
		margin: 0 0 28px;
		padding: 0;
		font-weight: 400;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-weight: 700;
		line-height: 1.2;
		margin: 0 0 10px;
	}
}
</style>
